import { useCallback } from "react";

import Typography from "@/foundation/Typography/V2";

import { classNameGenerator } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";

import styles from "./ReadyToBuildSection.module.scss";

interface ReadyToBuildSectionProps {
  setShowModal?: (showModal: boolean) => void;
}

const ReadyToBuildSection: React.FC<ReadyToBuildSectionProps> = ({
  setShowModal,
}) => {
  const dispatch = useAppDispatch();

  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  if(!data?.readyToBuildSection)
    return <></>
    
  const { packData, readyToBuildSection } = data || {};
  const { title, tagLine, ctaText } = readyToBuildSection || {};

  const setShowBookSlotModal = useCallback(
    (value: any) => {
      dispatch(actions.setShowBookSlotModal(value));
    },
    [dispatch]
  );

  return (
    <div className={cls("readyToBuildSection")}>
      <Typography variant="heading3" className={cls("title")}>
        {title}
      </Typography>
      <Typography variant="paragraph1" className={cls("description")}>
        <Typography
          variant="span"
          onClick={() => {
            if (setShowModal) {
              setShowModal(true);
            } else {
              setShowBookSlotModal({
                packageData: data?.packData,
              });
            }
          }}
        >
          Click here
        </Typography>
        {ctaText || ` to register for Shyft's ${packData?.title} today!`}
      </Typography>
      <Typography variant="paragraph1" className={cls("tagLine")}>
        {tagLine}
      </Typography>
    </div>
  );
};

export default ReadyToBuildSection;
